import React from "react"

import { Room } from "shared/types/Room"
import { RoomPrice } from "shared/types/__generated__/graphql"

import { RoomFormModel } from "features/room-management/types/RoomFormModel"
import { RoomCoreHandlers } from "features/room-management/types/RoomModel"

import { ProjectPageRoomSidebarView } from "./ProjectPageRoomSidebarView"
import { useProjectPageRoomSidebarViewModel } from "./hooks/useProjectPageRoomSidebarViewModel"

export interface ProjectPageRoomSidebarModel {
  projectID: string
  room: Room

  price?: RoomPrice | null | undefined
  isLoadingPrice?: boolean
  isPriceServiceAvailable?: boolean

  productTotal: number

  roomFormModel: RoomFormModel
  callbacks: RoomCoreHandlers

  isPending?: boolean
  isDisabled?: boolean

  hideControls?: boolean

  isEditing: boolean
  enterEditing: () => void
  exitEditing: () => void
  sidebarActiveTab: string | null
  setSidebarActiveTab: (tab: string | null) => void
}

export interface ProjectPageRoomSidebarProps
  extends ProjectPageRoomSidebarModel {
  id: string

  hidePrice?: boolean

  autoFocus?: boolean
}

export const ProjectPageRoomSidebar = React.memo(
  (props: ProjectPageRoomSidebarProps) => (
    <ProjectPageRoomSidebarView
      {...useProjectPageRoomSidebarViewModel(props)}
    />
  )
)
